module.exports = __webpack_public_path__ + "img/Libro2.508af44b.png";